import { useQuery } from '@tanstack/react-query';
import { fetchAllStudentClassRooms } from '../api/students';

const useFetchStudentAllClassrooms = (userId) => {
  return useQuery({
    queryKey: ['fetchingStudentAllClassrooms', userId],
    queryFn: async () => {
      if (!userId) return [];
      const fetchedData = await fetchAllStudentClassRooms(userId);

      if (!fetchedData?.status || !Array.isArray(fetchedData.classrooms)) {
        return [];
      }

      return fetchedData.classrooms.map((classroom) => ({
        classroomId: classroom?.classroomId,
        classroomName: classroom?.classroomName || '',
        primaryTeacherId: classroom?.primaryTeacher?.teacherId,
        primaryTeacher: classroom.primaryTeacher?.fullname || '',
        primaryTeacherEmail: classroom.primaryTeacher?.email || '',
        primaryTeacherPhotoURL: classroom.primaryTeacher?.photoURL || null,
      }));
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useFetchStudentAllClassrooms;




